import { SUGGESTER_STATE } from './constants'

export const getSuggestions = state => state[SUGGESTER_STATE].suggestions || []
export const getSuggesterSearch = state => state[SUGGESTER_STATE].search ?? ''
export const getSuggesterIsFetching = state => state[SUGGESTER_STATE].isFetching ?? false
export const getSuggesterIsFirstSearch = state => state[SUGGESTER_STATE].isFirstSearch ?? false
